import React from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Divider,
  Box,
  SxProps,
} from "@mui/material";
import "./ReusableCard.scss";

interface ReusableCardProps {
  title?: any;
  children: React.ReactNode;
  sx?: SxProps;
  contentSx?: SxProps;
}

const ReusableCard: React.FC<ReusableCardProps> = ({
  title,
  children,
  sx,
  contentSx,
}) => {
  return (
    <Card
      className="reusable-card"
      sx={{ boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)", borderRadius: 2, ...sx }}
    >
      {title && <CardHeader className="card-header" title={title} />}
      {title && <Divider />}
      <CardContent className="card-content" sx={contentSx}>
        <Box>{children}</Box>
      </CardContent>
    </Card>
  );
};

export default ReusableCard;
